import { CART_RECEIVE, CART_SHOW_INFO, SHOULD_SHOW_ERROR_MESSAGE} from '../Actions/Cart.action';

const DEFAULT_STATE = {
    visible: false,
    shouldClose: false,
    quantity: 0,
    items: [],
    shippingCost: 0,
    freeShippingMinimum: 0,
    orderTotal: 0,
}

export const cart = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
        case SHOULD_SHOW_ERROR_MESSAGE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}